<div class="profile-image-banner"></div>

<div class="card p-4 rounded-3 position-relative" style="margin-top: -100px">
  <div class="d-flex gap-4 align-items-center">
    <div class="flex-shrink-0">
      <img
        [src]="userDetails?.profile_image"
        width="100"
        height="100"
        class="rounded-circle border"
        (error)="onImageAvtrError($event)"
        alt="Profile Image"
      />
    </div>

    <div>
      <div class="text-muted small">@{{ userDetails?.username }}</div>
      <div class="d-flex align-items-center gap-2 fs-3 fw-semibold">
        {{ userDetails?.name }}
        <span class="user-role-chip">
          {{ userDetails?.roles?.[0]?.slug }}
        </span>
      </div>
      <div class="mt-2">{{ userDetails?.bio }}</div>
    </div>
  </div>

  <div class="row mt-4 g-3">
    <div class="col-md-6 col-lg-4 d-flex align-items-center gap-3">
      <img
        height="24"
        width="24"
        src="assets/images/building_grey.svg"
        alt="Organization"
      />
      <div>
        <div class="text-muted small">Organization</div>
        <div class="text-decoration-underline">
          {{ userDetails?.organisation?.name }}
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-4 d-flex align-items-center gap-3">
      <img
        height="24"
        width="24"
        src="assets/images/briefcase_person.svg"
        alt="Designation"
      />
      <div>
        <div class="text-muted small">Designation</div>
        <div>{{ userDetails?.designation }}</div>
      </div>
    </div>
  </div>
</div>

<mat-tab-group
  class="mt-4"
  [selectedIndex]="selectedTabIndex"
  (selectedTabChange)="onTabChange($event)"
>
  <mat-tab label="About"></mat-tab>
  <mat-tab label="Datasets"></mat-tab>
  <mat-tab label="Models"></mat-tab>
  <mat-tab label="Use Cases"></mat-tab>
  <!-- <mat-tab label="Toolkits"></mat-tab> -->
</mat-tab-group>

<!-- About User -->
<app-user-profile-about
  *ngIf="selectedTabIndex === 0"
  [userDetails]="userDetails"
  [statsDetails]="statsDetails"
  [socialLinks]="socialLinks"
  [mileStone]="mileStone"
  (statsCardClick)="onStatsCardClick($event)"
></app-user-profile-about>

<div class="container mt-4 mb-4">
  <div class="row py-3" *ngIf="selectedTabIndex === 1">
    <app-artifact-card
      class="col-12 col-sm-6 col-md-6 col-lg-4 mb-3"
      *ngFor="let relatedDataset of relatedDatasets"
      [datasetListItem]="relatedDataset"
    ></app-artifact-card>
    <app-no-record-found *ngIf="!totalCount"></app-no-record-found>
  </div>

  <div class="row py-3" *ngIf="selectedTabIndex === 2">
    <app-model-card
      class="col-12 col-sm-6 col-md-6 col-lg-4 mb-3"
      *ngFor="let relatedModel of relatedModels"
      [modelItem]="relatedModel"
    ></app-model-card>
    <app-no-record-found *ngIf="!totalCount"></app-no-record-found>
  </div>
  <div class="row py-3" *ngIf="selectedTabIndex === 3">
    <app-use-cases-card
      class="col-12 col-sm-6 col-md-6 col-lg-4 mb-3"
      *ngFor="let relatedUse of relatedUsecase"
      [useCaseItem]="relatedUse"
    ></app-use-cases-card>
    <app-no-record-found *ngIf="!totalCount"></app-no-record-found>
  </div>
  <div *ngIf="totalCount > 0">
    <mat-paginator
      [length]="totalCount"
      [pageSize]="limit"
      [pageIndex]="currentPage"
      [pageSizeOptions]="[12, 24, 36]"
      (page)="pageChanged($event)"
    ></mat-paginator>
  </div>
</div>
